import React, { useState } from "react";
import {
  AndroidOutlined,
  AppleOutlined,
  ArrowLeftOutlined,
  CloudUploadOutlined,
  MobileOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Button, Card, Col, Form, Input, Row, Select, Typography, notification } from "antd";
import { useNavigate } from "react-router-dom";
import AppVersionRequest from "./AppVersionRequest";
import IMAGES from "../../../../const/Image";
import "./AppVersion.css";

const { Text } = Typography;

const apps = [
  {
    value: "customer",
    label: "Customer",
    icon: <UserOutlined />,
  },
  {
    value: "partner",
    label: "Partner",
    icon: <TeamOutlined />,
  },
];

const platforms = [
  {
    value: "android",
    label: "Android",
    icon: <AndroidOutlined />,
  },
  {
    value: "ios",
    label: "iOS",
    icon: <AppleOutlined />,
  },
];

const CreateAppVersion = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = (values) => {
    setLoading(true);

    AppVersionRequest.createOrUpdate({
      app_type: values.app_type,
      platform: values.platform,
      version: values.version,
      force_update: values.force_update,
    })
      .then((res) => {
        notification.success({
          message: res?.data?.message || "App version updated successfully",
        });
        navigate("/app-setting/dashboard/app-version");
      })
      .catch((error) => {
        notification.error({
          message:
            error?.response?.data?.message ||
            "Failed to update app version",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <section className="app-version-page">
      <div className="app-version-header">
        <div>
          <h1 className="app-heading-med">Add App Version</h1>
        </div>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>

      <Row gutter={[18, 18]}>
        <Col xs={24}>
          <Card className="app-version-card app-version-form-card" title={null} bordered={false}>
            <div className="app-version-card-header">
              <div className="app-version-platform">
                <span className="app-version-platform-icon">
                  <img src={IMAGES.AppVersionIcon} alt="App Version" style={{ width: 24, height: 24, objectFit: "contain" }} />
                </span>
                <div>
                  <h2>Mobile App Version</h2>
                  <Text>Select app and platform before publishing a version.</Text>
                </div>
              </div>
            </div>

            <Form
              layout="vertical"
              onFinish={handleSubmit}
              initialValues={{ app_type: "customer", platform: "android", force_update: true }}
              className="app-version-form"
            >
              <Row gutter={[16, 16]}>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="App"
                    name="app_type"
                    rules={[{ required: true, message: "Please select app" }]}
                  >
                    <Select
                      size="large"
                      options={apps.map((app) => ({
                        value: app.value,
                        label: (
                          <span className="app-version-select-option">
                            {app.icon}
                            {app.label}
                          </span>
                        ),
                      }))}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item
                    label="Platform"
                    name="platform"
                    rules={[{ required: true, message: "Please select platform" }]}
                  >
                    <Select
                      size="large"
                      options={platforms.map((platform) => ({
                        value: platform.value,
                        label: (
                          <span className="app-version-select-option">
                            {platform.icon}
                            {platform.label}
                          </span>
                        ),
                      }))}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item
                    label="Version"
                    name="version"
                    rules={[
                      { required: true, message: "Please enter version" },
                      {
                        pattern: /^\d+(\.\d+){1,3}$/,
                        message: "Use version format like 1.0.0",
                      },
                    ]}
                  >
                    <Input size="large" placeholder="3.0.0" />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item
                    label="Force Update"
                    name="force_update"
                    rules={[{ required: true, message: "Please select force update" }]}
                  >
                    <Select
                      size="large"
                      options={[
                        { value: true, label: "True" },
                        { value: false, label: "False" },
                      ]}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div className="app-version-action-row">
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<CloudUploadOutlined />}
                  loading={loading}
                  className="app-version-submit"
                >
                  Update Version
                </Button>
              </div>
            </Form>
          </Card>
        </Col>
      </Row>
    </section>
  );
};

export default CreateAppVersion;
